// extracted by extract-css-chunks-webpack-plugin
module.exports = {"xxs":"360px","xs":"480px","sm":"865px","md":"960px","ticketBreak":"1264px","lg":"1366px","xl":"1600px","smallDevice":"595px","dashboardSmall":"1280px"};